/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { AIGenerateIcon } from '@coursera/cds-icons';
import type { ButtonName, LinkType, SectionName } from '@coursera/event-pulse-types';
import { useTracker, useVisibilityTracker } from '@coursera/event-pulse/react';

import DomainIcon from 'bundles/unified-common/components/pill/DomainIcon';
import Pill from 'bundles/unified-common/components/pill/Pill';

export type Domain = {
  id: string;
  name: string;
  slug?: string;
  href?: string;
  iconName?: 'AIGenerateIcon';
};

const styles = {
  pill: css`
    white-space: nowrap;
  `,
};

const DomainPill = ({ id, name, slug, href: hrefProp, iconName }: Domain) => {
  const track = useTracker();

  const href = hrefProp || `/browse/${slug || ''}`;

  const trackingData = {
    button: {
      name: 'lohp_browse_domain' satisfies ButtonName,
      linkType: 'internal' satisfies LinkType,
      linkName: slug || id,
      linkURL: href,
    },
    pageSection: {
      sectionName: 'browse_domains' satisfies SectionName,
    },
  } as const;

  const handleClick = () => {
    track('click_button', trackingData);
  };

  const visibilityTrackingRef: React.MutableRefObject<HTMLAnchorElement | null> = useVisibilityTracker(
    'view_button',
    trackingData,
    [],
    { fullyVisible: true }
  );

  let icon = null;
  switch (iconName) {
    case 'AIGenerateIcon':
      icon = <AIGenerateIcon />;
      break;
    default:
      break;
  }

  return (
    <Pill href={href} css={styles.pill} onClick={handleClick} ref={visibilityTrackingRef}>
      {slug ? <DomainIcon domain={{ slug, name }} /> : icon}
      {name}
    </Pill>
  );
};

export default DomainPill;
